module.exports = __webpack_public_path__ + "img/714.d65bc0f3.jpg";